// Dibangkitkan dari api/openapi.yaml (158 operasi pada 132 jalur). JANGAN disunting.
export const API_TITLE = "ASSIST by PQM — API Tahap 1";
export const API_VERSION = "1.0.0";
/**
 * Seluruh permukaan API, apa adanya dari kontrak.
 *
 * Uji kebocoran antar-tenant membangkitkan kasusnya dari daftar ini
 * (REPO-LAYOUT §3 gerbang 6), sehingga rute baru otomatis ikut diuji pada hari
 * ia ditambahkan — "lupa menambahkan uji" tidak mungkin terjadi.
 */
export const OPERATIONS = [
    {
        "operationId": "getActions",
        "method": "GET",
        "path": "/v1/actions",
        "summary": "Tindakan yang lahir dari rapat",
        "tags": [
            "M07"
        ],
        "requestSchema": null,
        "responseSchema": "GetActionsResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postActionsByCodeTransitions",
        "method": "POST",
        "path": "/v1/actions/{code}/transitions",
        "summary": "Jalankan transisi tindakan",
        "tags": [
            "M07"
        ],
        "requestSchema": "TransitionRequest",
        "responseSchema": "TransitionResult",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getAssessments",
        "method": "GET",
        "path": "/v1/assessments",
        "summary": "Daftar audit & asesmen",
        "tags": [
            "M03"
        ],
        "requestSchema": null,
        "responseSchema": "Assessment",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postAssessments",
        "method": "POST",
        "path": "/v1/assessments",
        "summary": "Jadwalkan atau mulai audit",
        "tags": [
            "M03"
        ],
        "requestSchema": "AssessmentCreate",
        "responseSchema": "Assessment",
        "responseStatus": 201,
        "isPublic": false
    },
    {
        "operationId": "getAssessmentsByAssessmentId",
        "method": "GET",
        "path": "/v1/assessments/{assessmentId}",
        "summary": "Detail asesmen",
        "tags": [
            "M03"
        ],
        "requestSchema": null,
        "responseSchema": "Assessment",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "putAssessmentsByAssessmentIdAnswers",
        "method": "PUT",
        "path": "/v1/assessments/{assessmentId}/answers",
        "summary": "Simpan jawaban kriteria (idempoten, boleh sebagian)",
        "tags": [
            "M03"
        ],
        "requestSchema": "AssessmentAnswerPut",
        "responseSchema": "Assessment",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getAssessmentsByAssessmentIdScorecard",
        "method": "GET",
        "path": "/v1/assessments/{assessmentId}/scorecard",
        "summary": "Kartu skor: total, pita, skor per kriteria",
        "tags": [
            "M03"
        ],
        "requestSchema": null,
        "responseSchema": "Assessment",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postAssessmentsByAssessmentIdTransitions",
        "method": "POST",
        "path": "/v1/assessments/{assessmentId}/transitions",
        "summary": "Mulai / kirim / batalkan asesmen",
        "tags": [
            "M03"
        ],
        "requestSchema": "TransitionRequest",
        "responseSchema": "Assessment",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getAssessmentsComparison",
        "method": "GET",
        "path": "/v1/assessments/comparison",
        "summary": "Bandingkan skor antar periode",
        "tags": [
            "M03"
        ],
        "requestSchema": null,
        "responseSchema": "Assessment",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postAssessmentsExports",
        "method": "POST",
        "path": "/v1/assessments/exports",
        "summary": "Minta ekspor kartu skor",
        "tags": [
            "M03"
        ],
        "requestSchema": "ReportRunRequest",
        "responseSchema": "ReportRun",
        "responseStatus": 202,
        "isPublic": false
    },
    {
        "operationId": "getAssets",
        "method": "GET",
        "path": "/v1/assets",
        "summary": "Daftar mesin/aset",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "GetAssetsResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postAssets",
        "method": "POST",
        "path": "/v1/assets",
        "summary": "Tambah mesin/aset",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "Asset",
        "responseStatus": 201,
        "isPublic": false
    },
    {
        "operationId": "postAuthAcceptInvitation",
        "method": "POST",
        "path": "/v1/auth/accept-invitation",
        "summary": "Terima undangan, setujui pemberitahuan privasi, tetapkan kata sandi pertama",
        "tags": [
            "M01"
        ],
        "requestSchema": "AcceptInvitationRequest",
        "responseSchema": "Session",
        "responseStatus": 200,
        "isPublic": true
    },
    {
        "operationId": "postAuthContextTenant",
        "method": "POST",
        "path": "/v1/auth/context/tenant",
        "summary": "Pindah konteks tenant (konsultan / admin platform)",
        "tags": [
            "M15"
        ],
        "requestSchema": "TenantContextSwitch",
        "responseSchema": "BoundContext",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postAuthForgotPassword",
        "method": "POST",
        "path": "/v1/auth/forgot-password",
        "summary": "Kirim tautan atur ulang, berlaku 30 menit",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "Acknowledged",
        "responseStatus": 202,
        "isPublic": true
    },
    {
        "operationId": "getAuthInvitationsByToken",
        "method": "GET",
        "path": "/v1/auth/invitations/{token}",
        "summary": "Siapa yang mengundang Anda",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "InvitationPreview",
        "responseStatus": 200,
        "isPublic": true
    },
    {
        "operationId": "postAuthRefresh",
        "method": "POST",
        "path": "/v1/auth/refresh",
        "summary": "Tukar refresh token (hanya ponsel)",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "Session",
        "responseStatus": 200,
        "isPublic": true
    },
    {
        "operationId": "postAuthResetPassword",
        "method": "POST",
        "path": "/v1/auth/reset-password",
        "summary": "Tetapkan kata sandi baru dari tautan",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "Acknowledged",
        "responseStatus": 200,
        "isPublic": true
    },
    {
        "operationId": "postAuthSignIn",
        "method": "POST",
        "path": "/v1/auth/sign-in",
        "summary": "Masuk dan muat entitlement",
        "tags": [
            "M01"
        ],
        "requestSchema": "SignInRequest",
        "responseSchema": "Session",
        "responseStatus": 200,
        "isPublic": true
    },
    {
        "operationId": "postAuthSignOut",
        "method": "POST",
        "path": "/v1/auth/sign-out",
        "summary": "Keluar dan cabut sesi ini",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "Acknowledged",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getBenefits",
        "method": "GET",
        "path": "/v1/benefits",
        "summary": "Klaim manfaat",
        "tags": [
            "M11"
        ],
        "requestSchema": null,
        "responseSchema": "GetBenefitsResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postBenefits",
        "method": "POST",
        "path": "/v1/benefits",
        "summary": "Catat klaim manfaat (belum terverifikasi)",
        "tags": [
            "M11"
        ],
        "requestSchema": "Benefit",
        "responseSchema": "Benefit",
        "responseStatus": 201,
        "isPublic": false
    },
    {
        "operationId": "postBenefitsByBenefitIdReject",
        "method": "POST",
        "path": "/v1/benefits/{benefitId}/reject",
        "summary": "Tolak klaim manfaat",
        "tags": [
            "M11"
        ],
        "requestSchema": null,
        "responseSchema": "Benefit",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postBenefitsByBenefitIdVerify",
        "method": "POST",
        "path": "/v1/benefits/{benefitId}/verify",
        "summary": "Sahkan manfaat (hanya pemegang hibah keuangan)",
        "tags": [
            "M11"
        ],
        "requestSchema": null,
        "responseSchema": "Benefit",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getDashboard",
        "method": "GET",
        "path": "/v1/dashboard",
        "summary": "Dasbor manajer area; AUD membukanya tanpa antrean keputusan",
        "tags": [
            "M11"
        ],
        "requestSchema": null,
        "responseSchema": "Dashboard",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getDashboardDecisionQueue",
        "method": "GET",
        "path": "/v1/dashboard/decision-queue",
        "summary": "Antrean keputusan: Approve / Decline / Request info",
        "tags": [
            "M11"
        ],
        "requestSchema": null,
        "responseSchema": "GetDashboardDecisionQueueResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getEscalationRules",
        "method": "GET",
        "path": "/v1/escalation-rules",
        "summary": "Tangga eskalasi tenant",
        "tags": [
            "M07"
        ],
        "requestSchema": null,
        "responseSchema": "EscalationRules",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "putEscalationRules",
        "method": "PUT",
        "path": "/v1/escalation-rules",
        "summary": "Ubah tangga eskalasi (dialog konfirmasi + audit)",
        "tags": [
            "M07"
        ],
        "requestSchema": "EscalationRules",
        "responseSchema": "EscalationRules",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getEscalations",
        "method": "GET",
        "path": "/v1/escalations",
        "summary": "Butir yang dieskalasi",
        "tags": [
            "M07"
        ],
        "requestSchema": null,
        "responseSchema": "GetEscalationsResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postFilesByFileIdCommit",
        "method": "POST",
        "path": "/v1/files/{fileId}/commit",
        "summary": "Sahkan unggahan yang sudah selesai",
        "tags": [
            "M15"
        ],
        "requestSchema": "FileCommitRequest",
        "responseSchema": "Acknowledged",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getFilesByFileIdDownloadUrl",
        "method": "GET",
        "path": "/v1/files/{fileId}/download-url",
        "summary": "Terbitkan presigned URL unduh, berlaku 15 menit",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "FileDownloadUrl",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postFilesUploadIntents",
        "method": "POST",
        "path": "/v1/files/upload-intents",
        "summary": "Terbitkan presigned URL untuk unggahan (ADR-8)",
        "tags": [
            "M15"
        ],
        "requestSchema": "UploadIntentRequest",
        "responseSchema": "UploadIntentResult",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getFindings",
        "method": "GET",
        "path": "/v1/findings",
        "summary": "Daftar temuan tersaring",
        "tags": [
            "M02"
        ],
        "requestSchema": null,
        "responseSchema": "GetFindingsResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postFindings",
        "method": "POST",
        "path": "/v1/findings",
        "summary": "Buat temuan (ULID dibuat klien)",
        "tags": [
            "M02"
        ],
        "requestSchema": "FindingCreate",
        "responseSchema": "Finding",
        "responseStatus": 201,
        "isPublic": false
    },
    {
        "operationId": "getFindingsByCode",
        "method": "GET",
        "path": "/v1/findings/{code}",
        "summary": "Detail temuan",
        "tags": [
            "M02"
        ],
        "requestSchema": null,
        "responseSchema": "Finding",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postFindingsByCodeAttachments",
        "method": "POST",
        "path": "/v1/findings/{code}/attachments",
        "summary": "Tautkan berkas yang sudah diunggah ke temuan",
        "tags": [
            "M02"
        ],
        "requestSchema": null,
        "responseSchema": "Attachment",
        "responseStatus": 201,
        "isPublic": false
    },
    {
        "operationId": "getFindingsByCodeComments",
        "method": "GET",
        "path": "/v1/findings/{code}/comments",
        "summary": "Komentar temuan",
        "tags": [
            "M02"
        ],
        "requestSchema": null,
        "responseSchema": "GetFindingsByCodeCommentsResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postFindingsByCodeComments",
        "method": "POST",
        "path": "/v1/findings/{code}/comments",
        "summary": "Tambah komentar",
        "tags": [
            "M02"
        ],
        "requestSchema": null,
        "responseSchema": "Acknowledged",
        "responseStatus": 201,
        "isPublic": false
    },
    {
        "operationId": "getFindingsByCodeEvents",
        "method": "GET",
        "path": "/v1/findings/{code}/events",
        "summary": "Riwayat peristiwa — sumber kebenaran",
        "tags": [
            "M02"
        ],
        "requestSchema": null,
        "responseSchema": "GetFindingsByCodeEventsResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postFindingsByCodeTransitions",
        "method": "POST",
        "path": "/v1/findings/{code}/transitions",
        "summary": "Jalankan satu transisi lewat TransitionService",
        "tags": [
            "M02"
        ],
        "requestSchema": "TransitionRequest",
        "responseSchema": "TransitionResult",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postFindingsBulkTransitions",
        "method": "POST",
        "path": "/v1/findings/bulk/transitions",
        "summary": "Transisi banyak temuan sekaligus",
        "tags": [
            "M02"
        ],
        "requestSchema": null,
        "responseSchema": "TransitionResult",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postFindingsExports",
        "method": "POST",
        "path": "/v1/findings/exports",
        "summary": "Minta ekspor CSV temuan",
        "tags": [
            "M02"
        ],
        "requestSchema": "ReportRunRequest",
        "responseSchema": "ReportRun",
        "responseStatus": 202,
        "isPublic": false
    },
    {
        "operationId": "getHome",
        "method": "GET",
        "path": "/v1/home",
        "summary": "Ringkasan Operator Home (kerangka M01, kartu dari modul ter-entitlement)",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "HomeSummary",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getInstruments",
        "method": "GET",
        "path": "/v1/instruments",
        "summary": "Instrumen audit yang terbit",
        "tags": [
            "M03"
        ],
        "requestSchema": null,
        "responseSchema": "Instrument",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getInstrumentsByInstrumentId",
        "method": "GET",
        "path": "/v1/instruments/{instrumentId}",
        "summary": "Instrumen beserta kriterianya",
        "tags": [
            "M03"
        ],
        "requestSchema": null,
        "responseSchema": "Instrument",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getInvitations",
        "method": "GET",
        "path": "/v1/invitations",
        "summary": "Undangan yang belum dipakai",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "GetInvitationsResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postInvitations",
        "method": "POST",
        "path": "/v1/invitations",
        "summary": "Undang pengguna",
        "tags": [
            "M01"
        ],
        "requestSchema": "InvitationRequest",
        "responseSchema": "User",
        "responseStatus": 201,
        "isPublic": false
    },
    {
        "operationId": "deleteInvitationsByInvitationId",
        "method": "DELETE",
        "path": "/v1/invitations/{invitationId}",
        "summary": "Tarik undangan",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "Acknowledged",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getItemCategories",
        "method": "GET",
        "path": "/v1/item-categories",
        "summary": "Kategori butir (5R + Safety)",
        "tags": [
            "M02"
        ],
        "requestSchema": null,
        "responseSchema": "GetItemCategoriesResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getLeaderboard",
        "method": "GET",
        "path": "/v1/leaderboard",
        "summary": "Papan peringkat periode berjalan",
        "tags": [
            "M10"
        ],
        "requestSchema": null,
        "responseSchema": "Leaderboard",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getLocations",
        "method": "GET",
        "path": "/v1/locations",
        "summary": "Daftar area",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "GetLocationsResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postLocations",
        "method": "POST",
        "path": "/v1/locations",
        "summary": "Tambah area",
        "tags": [
            "M01"
        ],
        "requestSchema": "LocationRequest",
        "responseSchema": "Location",
        "responseStatus": 201,
        "isPublic": false
    },
    {
        "operationId": "getLocationsByLocationId",
        "method": "GET",
        "path": "/v1/locations/{locationId}",
        "summary": "Detail area",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "Location",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "patchLocationsByLocationId",
        "method": "PATCH",
        "path": "/v1/locations/{locationId}",
        "summary": "Ubah atau pindahkan area",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "Location",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postLocationsByLocationIdDeactivate",
        "method": "POST",
        "path": "/v1/locations/{locationId}/deactivate",
        "summary": "Nonaktifkan area (data lama tetap terbaca)",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "Location",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getLocationsByLocationIdQrTags",
        "method": "GET",
        "path": "/v1/locations/{locationId}/qr-tags",
        "summary": "Label QR area",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "GetLocationsByLocationIdQrTagsResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postLocationsByLocationIdQrTags",
        "method": "POST",
        "path": "/v1/locations/{locationId}/qr-tags",
        "summary": "Terbitkan dan cetak label QR",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "QrTag",
        "responseStatus": 201,
        "isPublic": false
    },
    {
        "operationId": "getMe",
        "method": "GET",
        "path": "/v1/me",
        "summary": "Profil pengguna berjalan",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "Me",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "patchMe",
        "method": "PATCH",
        "path": "/v1/me",
        "summary": "Ubah profil dan bahasa",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "Me",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getMeAssignments",
        "method": "GET",
        "path": "/v1/me/assignments",
        "summary": "Klien yang ditugaskan kepada konsultan yang memanggil",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "GetMeAssignmentsResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getMeConsents",
        "method": "GET",
        "path": "/v1/me/consents",
        "summary": "Riwayat persetujuan saya, termasuk yang sudah ditarik",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "GetMeConsentsResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postMeConsents",
        "method": "POST",
        "path": "/v1/me/consents",
        "summary": "Catat persetujuan yang saya berikan sendiri",
        "tags": [
            "M01"
        ],
        "requestSchema": "ConsentRequest",
        "responseSchema": "ConsentResult",
        "responseStatus": 201,
        "isPublic": false
    },
    {
        "operationId": "postMeConsentsWithdraw",
        "method": "POST",
        "path": "/v1/me/consents/withdraw",
        "summary": "Tarik persetujuan dan nyatakan akibatnya",
        "tags": [
            "M01"
        ],
        "requestSchema": "ConsentWithdrawRequest",
        "responseSchema": "ConsentResult",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getMeContext",
        "method": "GET",
        "path": "/v1/me/context",
        "summary": "Konteks yang sedang terikat pada sesi ini",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "BoundContext",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getMeEntitlements",
        "method": "GET",
        "path": "/v1/me/entitlements",
        "summary": "Entitlement tenant berjalan — satu sumber kebenaran",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "Entitlements",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getMeNav",
        "method": "GET",
        "path": "/v1/me/nav",
        "summary": "Navigasi yang disusun dari manifest + entitlement",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "NavTree",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getMeNotificationPreferences",
        "method": "GET",
        "path": "/v1/me/notification-preferences",
        "summary": "Preferensi notifikasi",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "NotificationPreferences",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "putMeNotificationPreferences",
        "method": "PUT",
        "path": "/v1/me/notification-preferences",
        "summary": "Simpan preferensi notifikasi",
        "tags": [
            "M01"
        ],
        "requestSchema": "NotificationPreferences",
        "responseSchema": "NotificationPreferences",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getMePoints",
        "method": "GET",
        "path": "/v1/me/points",
        "summary": "Poin dan peringkat saya",
        "tags": [
            "M10"
        ],
        "requestSchema": null,
        "responseSchema": "Leaderboard",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getMeReports",
        "method": "GET",
        "path": "/v1/me/reports",
        "summary": "Riwayat laporan saya per bulan",
        "tags": [
            "M11"
        ],
        "requestSchema": null,
        "responseSchema": "GetMeReportsResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getMeSessions",
        "method": "GET",
        "path": "/v1/me/sessions",
        "summary": "Daftar perangkat yang masih masuk",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "GetMeSessionsResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "deleteMeSessionsBySessionId",
        "method": "DELETE",
        "path": "/v1/me/sessions/{sessionId}",
        "summary": "Keluarkan satu perangkat",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "Acknowledged",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getMeTasks",
        "method": "GET",
        "path": "/v1/me/tasks",
        "summary": "Tugas saya (Open / In progress / Verification)",
        "tags": [
            "M02"
        ],
        "requestSchema": null,
        "responseSchema": "GetMeTasksResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getMeetings",
        "method": "GET",
        "path": "/v1/meetings",
        "summary": "Daftar rapat",
        "tags": [
            "M07"
        ],
        "requestSchema": null,
        "responseSchema": "GetMeetingsResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postMeetings",
        "method": "POST",
        "path": "/v1/meetings",
        "summary": "Jadwalkan rapat harian",
        "tags": [
            "M07"
        ],
        "requestSchema": "MeetingCreate",
        "responseSchema": "Meeting",
        "responseStatus": 201,
        "isPublic": false
    },
    {
        "operationId": "getMeetingsByMeetingId",
        "method": "GET",
        "path": "/v1/meetings/{meetingId}",
        "summary": "Detail rapat beserta agenda dan peserta",
        "tags": [
            "M07"
        ],
        "requestSchema": null,
        "responseSchema": "Meeting",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "putMeetingsByMeetingIdAttendance",
        "method": "PUT",
        "path": "/v1/meetings/{meetingId}/attendance",
        "summary": "Catat kehadiran",
        "tags": [
            "M07"
        ],
        "requestSchema": "MeetingAttendancePut",
        "responseSchema": "Meeting",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postMeetingsByMeetingIdItems",
        "method": "POST",
        "path": "/v1/meetings/{meetingId}/items",
        "summary": "Tambah butir agenda",
        "tags": [
            "M07"
        ],
        "requestSchema": "MeetingItemCreate",
        "responseSchema": "MeetingItem",
        "responseStatus": 201,
        "isPublic": false
    },
    {
        "operationId": "patchMeetingsByMeetingIdItemsByMeetingItemId",
        "method": "PATCH",
        "path": "/v1/meetings/{meetingId}/items/{meetingItemId}",
        "summary": "Tandai butir dibahas atau buat tindakan",
        "tags": [
            "M07"
        ],
        "requestSchema": "MeetingItemPatch",
        "responseSchema": "MeetingItem",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postMeetingsByMeetingIdTransitions",
        "method": "POST",
        "path": "/v1/meetings/{meetingId}/transitions",
        "summary": "Mulai / tutup rapat",
        "tags": [
            "M07"
        ],
        "requestSchema": "TransitionRequest",
        "responseSchema": "Meeting",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getMetrics",
        "method": "GET",
        "path": "/v1/metrics",
        "summary": "Angka analitik untuk periode dan cakupan tertentu",
        "tags": [
            "M11"
        ],
        "requestSchema": null,
        "responseSchema": "Dashboard",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getNotifications",
        "method": "GET",
        "path": "/v1/notifications",
        "summary": "Kotak notifikasi, dikelompokkan Hari ini / Minggu ini",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "GetNotificationsResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postNotificationsRead",
        "method": "POST",
        "path": "/v1/notifications/read",
        "summary": "Tandai sudah dibaca",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "Acknowledged",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getOrgUnits",
        "method": "GET",
        "path": "/v1/org-units",
        "summary": "Pohon unit organisasi",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "GetOrgUnitsResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postOrgUnits",
        "method": "POST",
        "path": "/v1/org-units",
        "summary": "Tambah unit organisasi",
        "tags": [
            "M01"
        ],
        "requestSchema": "OrgUnitRequest",
        "responseSchema": "OrgUnit",
        "responseStatus": 201,
        "isPublic": false
    },
    {
        "operationId": "patchOrgUnitsByOrgUnitId",
        "method": "PATCH",
        "path": "/v1/org-units/{orgUnitId}",
        "summary": "Ubah unit organisasi",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "OrgUnit",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getPlatformAudit",
        "method": "GET",
        "path": "/v1/platform/audit",
        "summary": "Jejak audit tersaring",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "GetPlatformAuditResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getPlatformAuditAnchors",
        "method": "GET",
        "path": "/v1/platform/audit/anchors",
        "summary": "Jangkar rantai hash jejak audit",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "GetPlatformAuditAnchorsResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postPlatformAuditExports",
        "method": "POST",
        "path": "/v1/platform/audit/exports",
        "summary": "Ekspor jejak audit (ekspornya sendiri tercatat)",
        "tags": [
            "M15"
        ],
        "requestSchema": "AuditExportRequest",
        "responseSchema": "AuditExport",
        "responseStatus": 201,
        "isPublic": false
    },
    {
        "operationId": "getPlatformAuditIntegrity",
        "method": "GET",
        "path": "/v1/platform/audit/integrity",
        "summary": "Periksa rantai hash jejak audit",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "AuditIntegrity",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postPlatformBootstrap",
        "method": "POST",
        "path": "/v1/platform/bootstrap",
        "summary": "Admin platform pertama — sekali untuk selamanya",
        "tags": [
            "M15"
        ],
        "requestSchema": "PlatformBootstrapRequest",
        "responseSchema": "PlatformBootstrapResult",
        "responseStatus": 201,
        "isPublic": true
    },
    {
        "operationId": "getPlatformConsultantAssignments",
        "method": "GET",
        "path": "/v1/platform/consultant-assignments",
        "summary": "Penugasan konsultan ke tenant",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "GetPlatformConsultantAssignmentsResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postPlatformConsultantAssignments",
        "method": "POST",
        "path": "/v1/platform/consultant-assignments",
        "summary": "Tugaskan konsultan ke tenant",
        "tags": [
            "M15"
        ],
        "requestSchema": "ConsultantAssignmentCreate",
        "responseSchema": "ConsultantAssignment",
        "responseStatus": 201,
        "isPublic": false
    },
    {
        "operationId": "deletePlatformConsultantAssignmentsByConsultantUserIdByTenantId",
        "method": "DELETE",
        "path": "/v1/platform/consultant-assignments/{consultantUserId}/{tenantId}",
        "summary": "Cabut penugasan konsultan",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "Acknowledged",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getPlatformHealth",
        "method": "GET",
        "path": "/v1/platform/health",
        "summary": "Kesehatan sistem",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "SystemHealth",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getPlatformIncidents",
        "method": "GET",
        "path": "/v1/platform/incidents",
        "summary": "Insiden",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "GetPlatformIncidentsResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postPlatformIncidents",
        "method": "POST",
        "path": "/v1/platform/incidents",
        "summary": "Buka insiden",
        "tags": [
            "M15"
        ],
        "requestSchema": "IncidentCreate",
        "responseSchema": "Incident",
        "responseStatus": 201,
        "isPublic": false
    },
    {
        "operationId": "patchPlatformIncidentsByIncidentId",
        "method": "PATCH",
        "path": "/v1/platform/incidents/{incidentId}",
        "summary": "Perbarui atau tutup insiden",
        "tags": [
            "M15"
        ],
        "requestSchema": "IncidentPatch",
        "responseSchema": "Incident",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getPlatformJobs",
        "method": "GET",
        "path": "/v1/platform/jobs",
        "summary": "Riwayat job latar",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "GetPlatformJobsResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postPlatformJobsByJobRunIdRetry",
        "method": "POST",
        "path": "/v1/platform/jobs/{jobRunId}/retry",
        "summary": "Jalankan ulang job gagal",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "JobRun",
        "responseStatus": 202,
        "isPublic": false
    },
    {
        "operationId": "getPlatformMemberships",
        "method": "GET",
        "path": "/v1/platform/memberships",
        "summary": "Peran platform seluruh pegawai internal PQM",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "GetPlatformMembershipsResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postPlatformMemberships",
        "method": "POST",
        "path": "/v1/platform/memberships",
        "summary": "Beri atau ubah peran platform",
        "tags": [
            "M15"
        ],
        "requestSchema": "PlatformMembershipRequest",
        "responseSchema": "PlatformMembership",
        "responseStatus": 201,
        "isPublic": false
    },
    {
        "operationId": "deletePlatformMembershipsByUserId",
        "method": "DELETE",
        "path": "/v1/platform/memberships/{userId}",
        "summary": "Cabut peran platform",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "PlatformMembership",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getPlatformModules",
        "method": "GET",
        "path": "/v1/platform/modules",
        "summary": "Registry modul beserta manifestnya",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "GetPlatformModulesResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getPlatformPlans",
        "method": "GET",
        "path": "/v1/platform/plans",
        "summary": "Paket dan modul bawaannya",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "GetPlatformPlansResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getPlatformTenants",
        "method": "GET",
        "path": "/v1/platform/tenants",
        "summary": "Daftar tenant",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "GetPlatformTenantsResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postPlatformTenants",
        "method": "POST",
        "path": "/v1/platform/tenants",
        "summary": "Buat tenant",
        "tags": [
            "M15"
        ],
        "requestSchema": "TenantCreate",
        "responseSchema": "Tenant",
        "responseStatus": 201,
        "isPublic": false
    },
    {
        "operationId": "getPlatformTenantsByTenantId",
        "method": "GET",
        "path": "/v1/platform/tenants/{tenantId}",
        "summary": "Detail tenant",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "Tenant",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "patchPlatformTenantsByTenantId",
        "method": "PATCH",
        "path": "/v1/platform/tenants/{tenantId}",
        "summary": "Ubah identitas yang mengikat kontrak: nama badan hukum, slug, nama tampilan",
        "tags": [
            "M15"
        ],
        "requestSchema": "TenantUpdate",
        "responseSchema": "Tenant",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getPlatformTenantsByTenantIdEntitlements",
        "method": "GET",
        "path": "/v1/platform/tenants/{tenantId}/entitlements",
        "summary": "Entitlement tenant",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "Entitlements",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "putPlatformTenantsByTenantIdEntitlementsByModuleCode",
        "method": "PUT",
        "path": "/v1/platform/tenants/{tenantId}/entitlements/{moduleCode}",
        "summary": "Nyalakan/matikan modul pada tenant berjalan",
        "tags": [
            "M15"
        ],
        "requestSchema": "EntitlementUpdate",
        "responseSchema": "Entitlements",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postPlatformTenantsByTenantIdInvitations",
        "method": "POST",
        "path": "/v1/platform/tenants/{tenantId}/invitations",
        "summary": "Undang manajer pertama sebuah organisasi baru",
        "tags": [
            "M15"
        ],
        "requestSchema": "FirstManagerInvitationRequest",
        "responseSchema": "FirstManagerInvitationResult",
        "responseStatus": 201,
        "isPublic": false
    },
    {
        "operationId": "putPlatformTenantsByTenantIdPlan",
        "method": "PUT",
        "path": "/v1/platform/tenants/{tenantId}/plan",
        "summary": "Atur paket",
        "tags": [
            "M15"
        ],
        "requestSchema": "TenantPlanPut",
        "responseSchema": "Tenant",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postPlatformTenantsByTenantIdProcessingAgreement",
        "method": "POST",
        "path": "/v1/platform/tenants/{tenantId}/processing-agreement",
        "summary": "Catat persetujuan perjanjian pemrosesan data, lalu buka organisasinya",
        "tags": [
            "M15"
        ],
        "requestSchema": "AgreementAcceptRequest",
        "responseSchema": "AgreementAcceptResult",
        "responseStatus": 201,
        "isPublic": false
    },
    {
        "operationId": "postPlatformTenantsByTenantIdProvisioning",
        "method": "POST",
        "path": "/v1/platform/tenants/{tenantId}/provisioning",
        "summary": "Jalankan ulang penyediaan organisasi — kategori 5R dan alur kerja",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "ProvisioningResult",
        "responseStatus": 201,
        "isPublic": false
    },
    {
        "operationId": "getPlatformTenantsByTenantIdProvisioningLog",
        "method": "GET",
        "path": "/v1/platform/tenants/{tenantId}/provisioning-log",
        "summary": "Log penyediaan (irisan audit_log)",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "GetPlatformTenantsByTenantIdProvisioningLogResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postPlatformTenantsByTenantIdResume",
        "method": "POST",
        "path": "/v1/platform/tenants/{tenantId}/resume",
        "summary": "Aktifkan kembali tenant",
        "tags": [
            "M15"
        ],
        "requestSchema": "TenantSuspendRequest",
        "responseSchema": "Tenant",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postPlatformTenantsByTenantIdSuspend",
        "method": "POST",
        "path": "/v1/platform/tenants/{tenantId}/suspend",
        "summary": "Suspend tenant",
        "tags": [
            "M15"
        ],
        "requestSchema": "TenantSuspendRequest",
        "responseSchema": "Tenant",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getPlatformTenantsByTenantIdUsage",
        "method": "GET",
        "path": "/v1/platform/tenants/{tenantId}/usage",
        "summary": "Pemakaian per meter",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "UsageReport",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getPointLedger",
        "method": "GET",
        "path": "/v1/point-ledger",
        "summary": "Buku besar poin",
        "tags": [
            "M10"
        ],
        "requestSchema": null,
        "responseSchema": "GetPointLedgerResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postPointLedgerByLedgerIdApprove",
        "method": "POST",
        "path": "/v1/point-ledger/{ledgerId}/approve",
        "summary": "Setujui pemberian yang tertahan",
        "tags": [
            "M10"
        ],
        "requestSchema": null,
        "responseSchema": "PointLedgerEntry",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postPointLedgerByLedgerIdReverse",
        "method": "POST",
        "path": "/v1/point-ledger/{ledgerId}/reverse",
        "summary": "Batalkan pemberian (menulis baris REVERSED)",
        "tags": [
            "M10"
        ],
        "requestSchema": "PointReverseRequest",
        "responseSchema": "PointLedgerEntry",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getPointRules",
        "method": "GET",
        "path": "/v1/point-rules",
        "summary": "Aturan poin tenant",
        "tags": [
            "M10"
        ],
        "requestSchema": null,
        "responseSchema": "GetPointRulesResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postPointRules",
        "method": "POST",
        "path": "/v1/point-rules",
        "summary": "Tambah aturan poin",
        "tags": [
            "M10"
        ],
        "requestSchema": "PointRule",
        "responseSchema": "PointRule",
        "responseStatus": 201,
        "isPublic": false
    },
    {
        "operationId": "patchPointRulesByRuleCode",
        "method": "PATCH",
        "path": "/v1/point-rules/{ruleCode}",
        "summary": "Ubah atau tunda aturan poin",
        "tags": [
            "M10"
        ],
        "requestSchema": "PointRulePatch",
        "responseSchema": "PointRule",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getPrivacyNotice",
        "method": "GET",
        "path": "/v1/privacy-notice",
        "summary": "Pemberitahuan privasi versi berlaku, dua bahasa",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "PrivacyNotice",
        "responseStatus": 200,
        "isPublic": true
    },
    {
        "operationId": "getProcessingRegister",
        "method": "GET",
        "path": "/v1/processing-register",
        "summary": "Daftar pemrosesan, dirakit dari manifest modul",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "ProcessingRegister",
        "responseStatus": 200,
        "isPublic": true
    },
    {
        "operationId": "postQrTagsResolve",
        "method": "POST",
        "path": "/v1/qr-tags/resolve",
        "summary": "Pecahkan token QR menjadi area atau mesin",
        "tags": [
            "M01"
        ],
        "requestSchema": "QrResolveRequest",
        "responseSchema": "QrResolveResult",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getReportCatalog",
        "method": "GET",
        "path": "/v1/report-catalog",
        "summary": "Katalog laporan, disusun dari manifest modul ter-entitlement",
        "tags": [
            "M11"
        ],
        "requestSchema": null,
        "responseSchema": "GetReportCatalogResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postReportRuns",
        "method": "POST",
        "path": "/v1/report-runs",
        "summary": "Minta ekspor ad hoc",
        "tags": [
            "M11"
        ],
        "requestSchema": "ReportRunRequest",
        "responseSchema": "ReportRun",
        "responseStatus": 202,
        "isPublic": false
    },
    {
        "operationId": "getReportRunsByReportRunId",
        "method": "GET",
        "path": "/v1/report-runs/{reportRunId}",
        "summary": "Status ekspor dan tautan unduh",
        "tags": [
            "M11"
        ],
        "requestSchema": null,
        "responseSchema": "ReportRun",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getSavedReports",
        "method": "GET",
        "path": "/v1/saved-reports",
        "summary": "Laporan tersimpan dan terjadwal",
        "tags": [
            "M11"
        ],
        "requestSchema": null,
        "responseSchema": "GetSavedReportsResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postSavedReports",
        "method": "POST",
        "path": "/v1/saved-reports",
        "summary": "Simpan sebagai laporan terjadwal",
        "tags": [
            "M11"
        ],
        "requestSchema": "SavedReport",
        "responseSchema": "SavedReport",
        "responseStatus": 201,
        "isPublic": false
    },
    {
        "operationId": "deleteSavedReportsBySavedReportId",
        "method": "DELETE",
        "path": "/v1/saved-reports/{savedReportId}",
        "summary": "Hapus laporan tersimpan",
        "tags": [
            "M11"
        ],
        "requestSchema": null,
        "responseSchema": "Acknowledged",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "patchSavedReportsBySavedReportId",
        "method": "PATCH",
        "path": "/v1/saved-reports/{savedReportId}",
        "summary": "Ubah laporan tersimpan atau penerimanya",
        "tags": [
            "M11"
        ],
        "requestSchema": "SavedReportPatch",
        "responseSchema": "SavedReport",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postSavedReportsBySavedReportIdRuns",
        "method": "POST",
        "path": "/v1/saved-reports/{savedReportId}/runs",
        "summary": "Jalankan sekarang",
        "tags": [
            "M11"
        ],
        "requestSchema": null,
        "responseSchema": "ReportRun",
        "responseStatus": 202,
        "isPublic": false
    },
    {
        "operationId": "getSearch",
        "method": "GET",
        "path": "/v1/search",
        "summary": "Pencarian global lintas modul",
        "tags": [
            "M11"
        ],
        "requestSchema": null,
        "responseSchema": "SearchResults",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getSpotlight",
        "method": "GET",
        "path": "/v1/spotlight",
        "summary": "Sorotan periode berjalan",
        "tags": [
            "M07"
        ],
        "requestSchema": null,
        "responseSchema": "GetSpotlightResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postSpotlight",
        "method": "POST",
        "path": "/v1/spotlight",
        "summary": "Tambahkan ke sorotan",
        "tags": [
            "M07"
        ],
        "requestSchema": "SpotlightCreate",
        "responseSchema": "SpotlightEntry",
        "responseStatus": 201,
        "isPublic": false
    },
    {
        "operationId": "deleteSpotlightBySpotlightId",
        "method": "DELETE",
        "path": "/v1/spotlight/{spotlightId}",
        "summary": "Keluarkan dari sorotan",
        "tags": [
            "M07"
        ],
        "requestSchema": null,
        "responseSchema": "Acknowledged",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getSyncBootstrap",
        "method": "GET",
        "path": "/v1/sync/bootstrap",
        "summary": "Unduh paket kerja luring",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "SyncBootstrap",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getSyncChanges",
        "method": "GET",
        "path": "/v1/sync/changes",
        "summary": "Ambil perubahan sejak kursor",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "SyncChanges",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postSyncMutations",
        "method": "POST",
        "path": "/v1/sync/mutations",
        "summary": "Kirim batch mutasi luring (idempoten lewat ULID)",
        "tags": [
            "M15"
        ],
        "requestSchema": "SyncMutationBatch",
        "responseSchema": "SyncMutationResult",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getSyncMutationsByMutationId",
        "method": "GET",
        "path": "/v1/sync/mutations/{mutationId}",
        "summary": "Periksa hasil satu mutasi",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "SyncMutationResult",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getTenantAudit",
        "method": "GET",
        "path": "/v1/tenant/audit",
        "summary": "Jejak audit organisasi ini sendiri (butir P8)",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "GetTenantAuditResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getTenantIdentity",
        "method": "GET",
        "path": "/v1/tenant/identity",
        "summary": "Identitas organisasi sendiri — logo, warna aksen, nama tampilan, zona waktu, bahasa bawaan",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "TenantIdentity",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "patchTenantIdentity",
        "method": "PATCH",
        "path": "/v1/tenant/identity",
        "summary": "Ubah identitas organisasi sendiri (lingkup MGR)",
        "tags": [
            "M15"
        ],
        "requestSchema": "TenantIdentityUpdate",
        "responseSchema": "TenantIdentity",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getTenantProcessingAgreement",
        "method": "GET",
        "path": "/v1/tenant/processing-agreement",
        "summary": "Perjanjian pemrosesan data organisasi ini dan siapa yang menyetujuinya",
        "tags": [
            "M15"
        ],
        "requestSchema": null,
        "responseSchema": "TenantAgreement",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getTenantReadiness",
        "method": "GET",
        "path": "/v1/tenant/readiness",
        "summary": "Langkah yang tersisa sebelum organisasi ini dapat dipakai",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "TenantReadiness",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getUsers",
        "method": "GET",
        "path": "/v1/users",
        "summary": "Daftar pengguna dan perannya",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "GetUsersResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getUsersByUserId",
        "method": "GET",
        "path": "/v1/users/{userId}",
        "summary": "Detail pengguna",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "User",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "patchUsersByUserId",
        "method": "PATCH",
        "path": "/v1/users/{userId}",
        "summary": "Ubah pengguna",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "User",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getUsersByUserIdActivity",
        "method": "GET",
        "path": "/v1/users/{userId}/activity",
        "summary": "Aktivitas pengguna",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "GetUsersByUserIdActivityResponse",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postUsersByUserIdDeactivate",
        "method": "POST",
        "path": "/v1/users/{userId}/deactivate",
        "summary": "Nonaktifkan pengguna (tidak menghapus)",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "User",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postUsersByUserIdPasswordReset",
        "method": "POST",
        "path": "/v1/users/{userId}/password-reset",
        "summary": "Atur ulang kata sandi pengguna",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "Acknowledged",
        "responseStatus": 202,
        "isPublic": false
    },
    {
        "operationId": "putUsersByUserIdRole",
        "method": "PUT",
        "path": "/v1/users/{userId}/role",
        "summary": "Ubah peran dan cakupan area",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "User",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "postUsersByUserIdSessionsRevokeAll",
        "method": "POST",
        "path": "/v1/users/{userId}/sessions/revoke-all",
        "summary": "Keluarkan dari semua perangkat",
        "tags": [
            "M01"
        ],
        "requestSchema": null,
        "responseSchema": "Acknowledged",
        "responseStatus": 200,
        "isPublic": false
    },
    {
        "operationId": "getVerificationQueue",
        "method": "GET",
        "path": "/v1/verification-queue",
        "summary": "Antrean verifikasi dengan foto sebelum/sesudah",
        "tags": [
            "M02"
        ],
        "requestSchema": null,
        "responseSchema": "GetVerificationQueueResponse",
        "responseStatus": 200,
        "isPublic": false
    }
];
export const OPERATION_BY_ID = new Map(OPERATIONS.map((o) => [o.operationId, o]));
//# sourceMappingURL=operations.generated.js.map